import React, { useEffect, useState, useCallback } from "react";
import Navbar from "../../../components/navigation/Navbar";
import { Helmet } from "react-helmet";
import logo from '../../../media/branding/logo.png'
import backgroundImage from '../../../media/backgrounds/bg-2.png'
import { mainGet, mainPost } from "../../../domain/net/mainApi";
/* eslint-disable react-hooks/exhaustive-deps */

// Компонент модального окна подтверждения
const ConfirmationModal = ({ isOpen, onClose, onConfirm, title, message }) => {
    if (!isOpen) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.3)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1000
        }}>
            <div style={{
                backgroundColor: 'white',
                padding: '24px',
                borderRadius: '12px',
                maxWidth: '400px',
                width: '90%',
                boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
                border: '1px solid #e1e5e9'
            }}>
                <h3 style={{ margin: '0 0 12px 0', fontSize: '18px', fontWeight: '600', color: '#1a1a1a' }}>{title}</h3>
                <p style={{ margin: '0 0 24px 0', color: '#666', lineHeight: '1.4' }}>{message}</p>
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
                    <button
                        onClick={onClose}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#f8f9fa',
                            border: '1px solid #e1e5e9',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            color: '#666',
                            fontWeight: '500',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#e9ecef'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#f8f9fa'}
                    >
                        Отмена
                    </button>
                    <button
                        onClick={onConfirm}
                        style={{
                            padding: '10px 20px',
                            backgroundColor: '#dc2626',
                            color: 'white',
                            border: 'none',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            fontSize: '14px',
                            fontWeight: '500',
                            transition: 'all 0.2s ease'
                        }}
                        onMouseOver={(e) => e.target.style.backgroundColor = '#b91c1c'}
                        onMouseOut={(e) => e.target.style.backgroundColor = '#dc2626'}
                    >
                        Подтвердить
                    </button>
                </div>
            </div>
        </div>
    );
};

// Вспомогательные функции вынесены наверх
const addTimes = (timeArray) => {
    let totalMinutes = timeArray.reduce((acc, time) => {
        const [hours, minutes] = time.split('.');
        return acc + parseInt(hours) * 60 + parseInt(minutes);
    }, 0);

    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    return `${hours.toString().padStart(2, '0')}.${minutes.toString().padStart(2, '0')}`;
};

// Функция для преобразования времени в минуты
const timeToMinutes = (time) => {
    const [hours, minutes] = time.split('.');
    return parseInt(hours) * 60 + parseInt(minutes);
};

// Компонент карточки дня
const DayCard = ({ children, isToday, isStudent , id }) => (
    <div id={id}
         style={{
        background: 'white',
        borderRadius: '12px',
        padding: '20px',
        marginBottom: '16px',
        border: isToday ? '2px solid #10b981' : '1px solid #e1e5e9',
        boxShadow: '0 2px 8px rgba(0,0,0,0.04)',
        width: isStudent ? 'auto' : '100%',
        display: 'flex',
        flexDirection: 'column',
        gap: '16px'
    }}>
        {children}
    </div>
);

// Компонент кнопки
const Button = ({ children, onClick, variant = 'primary', disabled, ...props }) => {
    const baseStyle = {
        padding: '10px 20px',
        border: 'none',
        borderRadius: '8px',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontSize: '14px',
        fontWeight: '500',
        transition: 'all 0.2s ease',
        opacity: disabled ? 0.6 : 1
    };

    const variants = {
        primary: {
            backgroundColor: '#3b82f6',
            color: 'white',
            hoverColor: '#2563eb'
        },
        secondary: {
            backgroundColor: '#6b7280',
            color: 'white',
            hoverColor: '#4b5563'
        },
        danger: {
            backgroundColor: '#dc2626',
            color: 'white',
            hoverColor: '#b91c1c'
        },
        warning: {
            backgroundColor: '#f59e0b',
            color: 'white',
            hoverColor: '#d97706'
        }
    };

    const style = {
        ...baseStyle,
        backgroundColor: variants[variant].backgroundColor,
        color: variants[variant].color,
        ...props.style
    };

    return (
        <button
            onClick={disabled ? undefined : onClick}
            style={style}
            onMouseOver={(e) => !disabled && (e.target.style.backgroundColor = variants[variant].hoverColor)}
            onMouseOut={(e) => !disabled && (e.target.style.backgroundColor = variants[variant].backgroundColor)}
            {...props}
        >
            {children}
        </button>
    );
};

// Стилизованный компонент Select
const Select = ({ value, onChange, children, style = {}, ...props }) => {
    const selectStyle = {
        padding: '10px 12px',
        paddingRight: '32px',
        border: '1px solid #e1e5e9',
        borderRadius: '8px',
        fontSize: '14px',
        backgroundColor: 'white',
        color: '#1a1a1a',
        outline: 'none',
        transition: 'all 0.2s ease',
        cursor: 'pointer',
        appearance: 'none',
        backgroundImage: `url("data:image/svg+xml;charset=US-ASCII,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 4 5'><path fill='%236b7280' d='M2 0L0 2h4zm0 5L0 3h4z'/></svg>")`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right 12px center',
        backgroundSize: '8px 10px',
        ...style
    };

    return (
        <select
            value={value}
            onChange={onChange}
            style={selectStyle}
            onFocus={(e) => {
                e.target.style.borderColor = '#3b82f6';
                e.target.style.boxShadow = '0 0 0 3px rgba(59, 130, 246, 0.1)';
            }}
            onBlur={(e) => {
                e.target.style.borderColor = '#e1e5e9';
                e.target.style.boxShadow = 'none';
            }}
            onMouseOver={(e) => e.target.style.borderColor = '#d1d5db'}
            onMouseOut={(e) => e.target.style.borderColor = '#e1e5e9'}
            {...props}
        >
            {children}
        </select>
    );
};

// Компонент для загрузки файла
const FileUpload = ({ onFileSelect, accept, id, label }) => (
    <div>
        <label
            htmlFor={id}
            style={{
                color: "#3b82f6",
                fontSize: '14px',
                cursor: "pointer",
                textDecoration: 'underline',
                transition: 'color 0.2s ease'
            }}
            onMouseOver={(e) => e.target.style.color = '#2563eb'}
            onMouseOut={(e) => e.target.style.color = '#3b82f6'}
        >
            {label}
        </label>
        <input
            onChange={onFileSelect}
            accept={accept}
            style={{ display: "none" }}
            name={id}
            id={id}
            type='file'
        />
    </div>
);

// Хук для работы с query параметрами
const useQueryParams = () => {
    const getQueryParam = (key) => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(key);
    };

    const setQueryParam = (key, value) => {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set(key, value);
        window.history.replaceState({}, '', `${window.location.pathname}?${urlParams}`);
    };

    // Добавьте эту функцию
    const getAllParams = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const params = {};
        for (const [key, value] of urlParams.entries()) {
            params[key] = value;
        }
        return params;
    };

    return { getQueryParam, setQueryParam, getAllParams };
};

export default function Calendar(props) {
    const [user, setUser] = useState(props.user || {});
    const [calendar, setCalendar] = useState([]);
    const [studentCR, setStudentCR] = useState("");
    const [studentSEC, setStudentSEC] = useState("");
    const [all, setAll] = useState(null);
    const [timeCR, setTimeCR] = useState('07.00');
    const [durationCR, setDurationCR] = useState('00.30');
    const [priceCR, setPriceCR] = useState(1600);
    const [activeID, setActiveId] = useState(null);
    const [fixedStudents, setFixedStudents] = useState([]);
    const [isRequested, setRequested] = useState(false);
    const [isCreatingClass, setIsCreatingClass] = useState(false);
    const [paymentPhoto, setPaymentPhoto] = useState(null);
    // Добавляем состояние для хранения данных о днях рождения
    const [studentsWithBirthdays, setStudentsWithBirthdays] = useState([]);

    const [lastActiveDateId, setLastActiveDateId] = useState(null);

    useEffect(() => {
        if (lastActiveDateId && calendar.length > 0) {
            // Небольшая задержка чтобы DOM успел отрендериться
            const timer = setTimeout(() => {
                const element = document.getElementById(`date-${lastActiveDateId}`);
                if (element) {
                    console.log('Scrolling to element:', `date-${lastActiveDateId}`);
                    element.scrollIntoView({
                        behavior: 'smooth',
                        block: 'center',
                        inline: 'nearest'
                    });
                }
            }, 200);

            return () => clearTimeout(timer);
        }
    }, [lastActiveDateId, calendar]);

    const { getQueryParam, setQueryParam } = useQueryParams();

    // Инициализация периода из query параметров или по умолчанию 1
    const [period, setPeriod] = useState(() => {
        const savedPeriod = getQueryParam('period');
        return savedPeriod ? parseInt(savedPeriod) : 1;
    });

    useEffect(() => {
        const savedDateId = getQueryParam('lastActiveDate');
        if (savedDateId) {
            setLastActiveDateId(savedDateId);
        }
    }, [])

    const [modal, setModal] = useState({
        isOpen: false,
        title: '',
        message: '',
        onConfirm: null,
        actionType: null,
        data: null
    });

    const date = new Date();
    const currentYear = date.getFullYear();
    const currentMonth = (date.getMonth() + 1).toString().padStart(2, '0');
    const currentDay = date.getDate();

    // Генерация дат
    const generateDates = useCallback(() => {
        const dates = [];
        for (let i = 0; i <= 59; i++) {
            const futureDate = new Date(date.getTime() + i * 86400000);
            const month = (futureDate.getMonth() + 1).toString().padStart(2, '0');
            const day = futureDate.getDate();
            dates.push({ m: month, d: day, i });
        }
        return dates;
    }, [date]);

    const generateTimes = useCallback(() => {
        const times = [];
        let lastTime = '06.30';
        for (let i = 0; i < 27; i++) {
            lastTime = addTimes([lastTime, '00.30']);
            times.push({ d: lastTime, i });
        }
        return times;
    }, []);

    const [dates] = useState(generateDates);
    const [times] = useState(generateTimes);
    const [durationOptions] = useState([
        { d: '00.30', i: 0, p: 1600, minutes: 30 },
        { d: '01.00', i: 1, p: 3200, minutes: 60 },
        { d: '01.30', i: 2, p: 4800, minutes: 90 },
        { d: '02.00', i: 3, p: 6400, minutes: 120 }
    ]);

    const clearAddTimes = useCallback((time) => {
        const [hours, minutes] = time.split('.');
        return `${hours.padStart(2, '0')}.${minutes}`;
    }, []);

    // Функция для получения доступных длительностей
    const getAvailableDurations = useCallback((selectedTime, selectedDate, allClasses) => {
        if (!selectedTime || !allClasses) return durationOptions;

        const selectedTimeMinutes = timeToMinutes(selectedTime);
        const classesForDate = allClasses.filter(cls =>
            cls.date === selectedDate && cls.state === "1"
        );

        if (classesForDate.length === 0) return durationOptions;

        // Находим ближайшее следующее занятие
        const nextClasses = classesForDate.filter(cls => {
            const classStartMinutes = timeToMinutes(cls.time);
            return classStartMinutes > selectedTimeMinutes;
        });

        if (nextClasses.length === 0) return durationOptions;

        const nearestNextClass = nextClasses.reduce((nearest, cls) => {
            const classStartMinutes = timeToMinutes(cls.time);
            return classStartMinutes < timeToMinutes(nearest.time) ? cls : nearest;
        });

        const nextClassStartMinutes = timeToMinutes(nearestNextClass.time);
        const maxAvailableMinutes = nextClassStartMinutes - selectedTimeMinutes;

        // Фильтруем доступные длительности
        return durationOptions.filter(option =>
            option.minutes <= maxAvailableMinutes
        );
    }, [durationOptions]);

    // Функция для загрузки данных о днях рождения студентов
    const getStudentsWithBirthdays = useCallback(() => {
        mainGet({ type: 'getglobalstudents', id: localStorage.getItem('clid') })
            .then(response => {
                if (response?.data !== null) {
                    setStudentsWithBirthdays(response.data);
                } else {
                    console.error("Ошибка загрузки данных о студентах:", response.data);
                }
            })
            .catch(error => {
                console.error("Ошибка загрузки данных о студентах:", error);
            });
    }, []);

    // Функция проверки совпадения дня рождения с датой занятия
    const isBirthdayMatch = useCallback((classData) => {
        if (!studentsWithBirthdays?.length) return false;

        // Находим студента по имени и фамилии
        const student = studentsWithBirthdays.find(student => {
            const studentFullName = `${student.name} ${student.sname}`;
            return studentFullName === classData.student;
        });

        if (!student || !student.bday) return false;

        // Преобразуем дату занятия в формат d.m
        const classDateParts = classData.date.split('-');
        const classDayMonth = `${classDateParts[2]}.${classDateParts[1]}`;

        // Преобразуем день рождения в формат d.m (игнорируем год)
        const birthdayParts = student.bday.split('.');
        if (birthdayParts.length < 2) return false;

        const birthdayDayMonth = `${birthdayParts[0]}.${birthdayParts[1]}`;
        console.log(birthdayDayMonth, classDayMonth);

        return classDayMonth === birthdayDayMonth;
    }, [studentsWithBirthdays]);

    const showConfirmation = useCallback((title, message, onConfirm, data = null, actionType = null) => {
        setModal({
            isOpen: true,
            title,
            message,
            onConfirm,
            data,
            actionType
        });
    }, []);

    const closeModal = useCallback(() => {
        setModal({
            isOpen: false,
            title: '',
            message: '',
            onConfirm: null,
            data: null,
            actionType: null
        });
    }, []);

    const createClass = useCallback((dt) => {
        if (isCreatingClass) return;

        if (!studentCR) {
            alert("Выберите ученицу");
            return;
        }

        setIsCreatingClass(true);
        const formattedDate = `${currentYear}-${dt.m}-${dt.d.toString().padStart(2, '0')}`;
        mainPost({
            type: 'crClass',
            id: localStorage.getItem('clid'),
            dur: durationCR,
            student: user.role === 'student' ? (user.name + ' ' + user.sname) : studentCR,
            time: timeCR,
            price: priceCR,
            date: formattedDate,
            ss: studentSEC || undefined
        })
            .then(resp => {
                if (resp.data.ok) {
                    window.location.reload();
                } else {
                    alert(`Ошибка создания занятия\nКод: ${resp.data.type}`);
                }
            })
            .catch(error => {
                console.error("Ошибка создания занятия:", error);
                alert("Произошла ошибка при создании занятия");
            })
            .finally(() => {
                setIsCreatingClass(false);
            });
    }, [isCreatingClass, studentCR, durationCR, timeCR, priceCR, studentSEC, user, currentYear]);

    const studentCreateClass = useCallback((dateStr) => {
        if (isCreatingClass) return;

        if (!paymentPhoto) {
            alert("Для создания занятия необходимо прикрепить скриншот об оплате");
            return;
        }

        setIsCreatingClass(true);
        const formattedDate = `${dateStr.split('-')[2]}-${dateStr.split('-')[1]}-${dateStr.split('-')[0]}`;
        const data = new FormData();
        data.append('payment-screen', paymentPhoto);

        mainPost({
            type: 'createStudentClass',
            date: formattedDate,
            student: user?.name + ' ' + user?.sname,
            coach: user?.fixed_trainer,
            timePer: `${timeCR}-${addTimes([timeCR, durationCR])}`,
            price: priceCR,
            dur: durationCR,
            time: timeCR
        }, data)
            .then(res => {
                if (res.data.ok) {
                    window.location.reload();
                } else {
                    alert('Произошла ошибка создания занятия');
                    console.error(res.data);
                }
            })
            .catch(error => {
                console.error("Ошибка создания занятия:", error);
                alert("Произошла ошибка при создании занятия");
            })
            .finally(() => {
                setIsCreatingClass(false);
            });
    }, [isCreatingClass, paymentPhoto, user, timeCR, durationCR, priceCR]);

    const deleteClass = useCallback((id) => {
        showConfirmation(
            "Удаление занятия",
            "Вы уверены, что хотите удалить это занятие?",
            () => {
                mainGet({ type: 'delClass', id: localStorage.getItem('clid'), classId: id })
                    .then(resp => {
                        if (resp.data.ok) {
                            window.location.reload();
                        } else {
                            alert(`Ошибка удаления занятия\nКод: ${resp.data.type}`);
                        }
                    })
                    .catch(error => {
                        console.error("Ошибка удаления занятия:", error);
                        alert("Произошла ошибка при удалении занятия");
                    });
                closeModal();
            },
            id,
            'delete'
        );
    }, [showConfirmation, closeModal]);

    const cancelClass = useCallback((classData) => {
        showConfirmation(
            "Отмена занятия",
            "Вы уверены, что хотите отменить это занятие?",
            () => {
                const text = `${user.name} ${user.sname} отменила занятие на ${classData.date.split('-')[2]} ${getMonthName(classData.date.split('-')[1])} ${classData.date.split('-')[0]} и время ${classData.time} - ${addTimes([classData.time, classData.duration])}`;

                const toUser = user.role === 'student' ? user.fixed_trainer : user.public_key;

                mainGet({
                    type: 'addNotif',
                    to: toUser,
                    from: user.public_key,
                    date: classData.date,
                    typ: encodeURIComponent(text)
                })
                    .then(response => {
                        if (!response.data.ok) {
                            alert('Произошла ошибка отмены занятия');
                        } else {
                            mainGet({ type: 'cancelClass', classId: classData.id })
                                .then(response => {
                                    if (!response.data.ok) {
                                        alert('Произошла ошибка отмены занятия');
                                    } else {
                                        window.location.reload();
                                    }
                                });
                        }
                    })
                    .catch(error => {
                        console.error("Ошибка отмены занятия:", error);
                        alert("Произошла ошибка при отмене занятия");
                    });
                closeModal();
            },
            classData,
            'cancel'
        );
    }, [user, showConfirmation, closeModal]);

    const getMonthName = useCallback((monthNumber) => {
        const date = new Date();
        date.setMonth(monthNumber - 1);
        return date.toLocaleString([], { month: 'long' });
    }, []);

    const getDayOfWeek = useCallback((dateStr) => {
        const dayOfWeek = new Date(dateStr).getDay();
        return isNaN(dayOfWeek) ? null :
            ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'][dayOfWeek];
    }, []);

    const getFixedStudents = useCallback(() => {
        mainGet({ type: 'getCoachStudents', coach: localStorage.getItem('clid') })
            .then(response => {
                if (response.data.ok) {
                    setFixedStudents(response.data.data);
                } else {
                    alert('Произошла ошибка загрузки учениц');
                }
            })
            .catch(error => {
                console.error("Ошибка загрузки учениц:", error);
                alert('Произошла ошибка загрузки учениц');
            });
    }, []);

    const getClasses = useCallback(() => {
        mainGet({
            type: 'getClassesForWeek',
            s: `${currentYear}-${currentMonth}-${date.getDate()}`,
            id: localStorage.getItem('clid')
        })
            .then(resp => {
                if (resp.data.ok) {
                    setCalendar(resp.data.data);
                }
            })
            .catch(error => {
                console.error("Ошибка загрузки занятий:", error);
            });
    }, [currentYear, currentMonth, date]);

    const availClasses = useCallback(() => {
        if (!user.name || !dates.length || isRequested) return;

        const coachId = user.role === 'student' ? user.fixed_trainer : user.public_key;
        const dateStr = `${currentYear}-${currentMonth}-${dates[0]?.d.toString().padStart(2, '0')}`;

        mainGet({ type: 'availClasses', dayId: dateStr, coach: coachId })
            .then(rs => {
                if (rs.data.ok) {
                    setAll(rs.data.data);
                } else {
                    console.error("Ошибка доступных занятий:", rs.data.type);
                }
            })
            .catch(error => {
                console.error("Ошибка загрузки доступных занятий:", error);
            });

        setRequested(true);
    }, [user, currentYear, currentMonth, dates, isRequested]);

    const catchPhoto = useCallback((e) => {
        if (e.target.files && e.target.files[0]) {
            setPaymentPhoto(e.target.files[0]);
        }
    }, []);

    // Обработчик изменения периода
    const handlePeriodChange = useCallback((newPeriod) => {
        setPeriod(newPeriod);
        setQueryParam('period', newPeriod.toString());
    }, [setQueryParam]);

    // Функция для обновления активной даты взаимодействия
    const updateLastActiveDate = useCallback((dateId) => {
        setLastActiveDateId(dateId);
        setQueryParam('lastActiveDate', dateId);
    }, [setQueryParam]);

    useEffect(() => {
        if (props.user?.name && !user.name) {
            setUser(props.user);
        }
    }, [props.user, user.name]);

    useEffect(() => {
        getClasses();
        if (user?.role !== 'student' && user?.name) {
            getFixedStudents();
        }
        // Загружаем данные о днях рождения при инициализации
        getStudentsWithBirthdays();
    }, [user?.role, user?.name]);

    useEffect(() => {
        if (user.name && dates.length > 0 && !isRequested && !all) {
            availClasses();
        }
    }, [user.name, dates.length, isRequested, all, availClasses]);

    return (
        <div className="App" style={{
            minHeight: '100vh',
            padding: '20px 16px 80px 16px',
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'bottom',
            backgroundAttachment: 'fixed',
            backgroundRepeat: 'no-repeat'
        }}>
            {/* Затемнение для лучшей читаемости контента */}
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(255, 255, 255, 0.9)',
                zIndex: -1
            }} />

            <Helmet>
                <title>Календарь</title>
                <link rel="shortcut icon" href={logo} />
            </Helmet>

            <ConfirmationModal
                isOpen={modal.isOpen}
                onClose={closeModal}
                onConfirm={modal.onConfirm}
                title={modal.title}
                message={modal.message}
            />

            <div style={{ maxWidth: '700px', margin: '0 auto', position: 'relative' }}>
                <div style={{
                    textAlign: 'center',
                    marginBottom: '32px',
                    padding: '0 16px'
                }}>
                    <h1 style={{
                        fontSize: '28px',
                        fontWeight: '700',
                        color: '#1a1a1a',
                        margin: '0 0 8px 0'
                    }}>
                        Календарь
                    </h1>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '12px',
                        flexWrap: 'wrap'
                    }}>
                        <span style={{
                            color: '#6b7280',
                            fontSize: '16px'
                        }}>
                            Период:
                        </span>
                        <Select
                            value={period}
                            onChange={e => handlePeriodChange(Number(e.target.value))}
                            style={{ width: '120px' }}
                        >
                            <option value={1}>1 день</option>
                            <option value={7}>7 дней</option>
                            <option value={30}>30 дней</option>
                            <option value={60}>60 дней</option>
                        </Select>
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                    {dates.slice(0, period).map(el => {
                        const formattedDate = `${currentYear}-${el.m}-${el.d.toString().padStart(2, '0')}`;
                        const dayClasses = calendar?.filter(d => d.date === formattedDate) || [];
                        const availableDurations = getAvailableDurations(timeCR, formattedDate, all);
                        const isToday = el.d === currentDay && el.m === currentMonth;

                        return (
                            <DayCard key={el.i} isStudent={user?.role === 'student'} isToday={isToday} id={`date-${el.i}`}>
                                {/* Заголовок дня */}
                                <div style={{
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: '16px'
                                }}>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '12px',
                                        paddingBottom: '12px',
                                        borderBottom: '1px solid #f1f5f9'
                                    }}>
                                        <div style={{
                                            display: 'flex',
                                            flexDirection: 'column'
                                        }}>
                                            <h3 style={{
                                                fontSize: '16px',
                                                fontWeight: '600',
                                                color: '#6b7280',
                                                margin: '0 0 4px 0'
                                            }}>
                                                {getDayOfWeek(Date.now() + 86400000 * el.i)}
                                            </h3>
                                            <h3 style={{
                                                fontSize: '20px',
                                                fontWeight: '700',
                                                color: '#1a1a1a',
                                                margin: 0
                                            }}>
                                                {el.d}.{el.m}.{currentYear}
                                                {isToday && (
                                                    <span style={{
                                                        fontSize: '12px',
                                                        fontWeight: '500',
                                                        color: '#10b981',
                                                        marginLeft: '8px',
                                                        backgroundColor: '#ecfdf5',
                                                        padding: '2px 8px',
                                                        borderRadius: '12px'
                                                    }}>
                                                        Сегодня
                                                    </span>
                                                )}
                                            </h3>
                                        </div>
                                    </div>

                                    {/* Форма создания занятия */}
                                    <div style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        gap: '12px'
                                    }}>
                                        {user?.role !== 'student' ? (
                                            // Интерфейс тренера
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'flex-start',
                                                gap: '12px',
                                                flexWrap: 'wrap'
                                            }}>
                                                <div style={{
                                                    display: 'flex',
                                                    flexDirection: 'column',
                                                    gap: '8px',
                                                    minWidth: '200px'
                                                }}>
                                                    <Select
                                                        value={activeID === el.i ? studentCR : ''}
                                                        onChange={e => {
                                                            setStudentCR(e.target.value);
                                                            setActiveId(el.i);
                                                            updateLastActiveDate(el.i.toString());
                                                        }}
                                                        style={{ width: '100%' }}
                                                    >
                                                        <option value="">Первая ученица</option>
                                                        {fixedStudents.map(st => {
                                                            if (st?.archived === "0")
                                                                return <option key={st.id} value={st.name + ' ' + st.sname}>
                                                                {st.name + ' ' + st.sname}
                                                            </option>
                                                            else return null
                                                        })}
                                                    </Select>

                                                    <Select
                                                        value={activeID === el.i ? studentSEC : ''}
                                                        onChange={e => {
                                                            setStudentSEC(e.target.value);
                                                            setActiveId(el.i);
                                                        }}
                                                        style={{ width: '100%' }}
                                                    >
                                                        <option value="">Вторая ученица</option>
                                                        {fixedStudents.map(st => (
                                                            <option key={st.id} value={st.name + ' ' + st.sname}>
                                                                {st.name + ' ' + st.sname}
                                                            </option>
                                                        ))}
                                                    </Select>
                                                </div>

                                                <TimeDurationSelectors
                                                    el={el}
                                                    activeID={activeID}
                                                    timeCR={timeCR}
                                                    durationCR={durationCR}
                                                    setTimeCR={setTimeCR}
                                                    setDurationCR={setDurationCR}
                                                    setPriceCR={setPriceCR}
                                                    setActiveId={setActiveId}
                                                    times={times}
                                                    durationOptions={durationOptions}
                                                    availableDurations={availableDurations}
                                                    all={all}
                                                    currentYear={currentYear}
                                                    updateLastActiveDate={updateLastActiveDate}
                                                />

                                                <Button
                                                    onClick={() => {
                                                        createClass(el)
                                                        updateLastActiveDate(el.i.toString());
                                                    }}
                                                    disabled={isCreatingClass}
                                                >
                                                    {isCreatingClass ? 'Создаем...' : 'Создать'}
                                                </Button>
                                            </div>
                                        ) : (
                                            // Интерфейс студента
                                            <div style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                gap: '12px',
                                                flexWrap: 'wrap'
                                            }}>
                                                <TimeDurationSelectors
                                                    el={el}
                                                    activeID={activeID}
                                                    timeCR={timeCR}
                                                    durationCR={durationCR}
                                                    setTimeCR={setTimeCR}
                                                    setDurationCR={setDurationCR}
                                                    setPriceCR={setPriceCR}
                                                    setActiveId={setActiveId}
                                                    times={times}
                                                    durationOptions={durationOptions}
                                                    availableDurations={availableDurations}
                                                    all={all}
                                                    currentYear={currentYear}
                                                    updateLastActiveDate={updateLastActiveDate}
                                                />

                                                <Button
                                                    onClick={() => {
                                                        studentCreateClass(formattedDate)
                                                        updateLastActiveDate(el.i.toString());
                                                    }}
                                                    disabled={!paymentPhoto || isCreatingClass}
                                                >
                                                    {isCreatingClass ? 'Создаем...' : 'Создать'}
                                                </Button>

                                                <FileUpload
                                                    onFileSelect={catchPhoto}
                                                    accept="image/*"
                                                    id="payment-screen"
                                                    label="Прикрепить скриншот оплаты"
                                                />
                                            </div>
                                        )}

                                        {paymentPhoto && activeID === el.i && (
                                            <div style={{ marginTop: '8px' }}>
                                                <img
                                                    style={{
                                                        objectFit: "cover",
                                                        width: 200,
                                                        height: 300,
                                                        borderRadius: '8px',
                                                        border: '1px solid #e1e5e9'
                                                    }}
                                                    alt='paymentPhoto'
                                                    src={URL.createObjectURL(paymentPhoto)}
                                                />
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Список занятий на день */}
                                {dayClasses.length > 0 && (
                                    <div style={{
                                        borderTop: '1px solid #e1e5e9',
                                        paddingTop: '16px'
                                    }}>
                                        <h4 style={{
                                            fontSize: '16px',
                                            fontWeight: '600',
                                            color: '#6b7280',
                                            margin: '0 0 12px 0'
                                        }}>
                                            Запланированные занятия ({dayClasses.length})
                                        </h4>
                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                                            {dayClasses.map(classData => (
                                                <ClassItem
                                                    key={classData.id}
                                                    classData={classData}
                                                    user={user}
                                                    deleteClass={deleteClass}
                                                    cancelClass={cancelClass}
                                                    clearAddTimes={clearAddTimes}
                                                    isBirthdayMatch={isBirthdayMatch(classData)}
                                                />
                                            ))}
                                        </div>
                                    </div>
                                )}
                            </DayCard>
                        );
                    })}
                </div>
            </div>

            <Navbar usertype={props.role} fixedT={user?.fixed_trainer} />
        </div>
    );
}

// Компонент выбора времени и длительности
function TimeDurationSelectors({
                                   el, activeID, timeCR, durationCR, setTimeCR, setDurationCR, setPriceCR, setActiveId,
                                   times, durationOptions, availableDurations, all, currentYear, updateLastActiveDate
                               }) {
    return (
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center', flexWrap: 'wrap' }}>
            <Select
                value={activeID === el.i ? timeCR : ''}
                onChange={e => {
                    setTimeCR(e.target.value);
                    setActiveId(el.i);
                    updateLastActiveDate(el.i.toString());
                    // Сбрасываем длительность при смене времени
                    setDurationCR('00.30');
                    setPriceCR(1600);
                }}
                style={{ width: '100px' }}
            >
                <option value="" disabled>Время</option>
                {times.map(tm => {
                    let timeAvail = true;
                    if (all) {
                        all.forEach(al => {
                            const isSameDate = al.date === `${currentYear}-${el.m}-${el.d.toString().padStart(2, '0')}`;
                            const isTimeOverlap = tm.d >= al.time && tm.d < addTimes([al.time, al.duration]);
                            if (isSameDate && isTimeOverlap && al.state === "1") {
                                timeAvail = false;
                            }
                        });
                    }
                    return timeAvail ? (
                        <option key={tm.i} value={tm.d}>{tm.d}</option>
                    ) : null;
                })}
            </Select>

            <Select
                value={activeID === el.i ? durationCR : ''}
                onChange={e => {
                    setDurationCR(e.target.value);
                    setActiveId(el.i);
                    updateLastActiveDate(el.i.toString());
                    const selectedDuration = durationOptions.find(t => t.d === e.target.value);
                    if (selectedDuration) {
                        setPriceCR(selectedDuration.p);
                    }
                }}
                style={{
                    width: '150px',
                    backgroundColor: availableDurations.length === 0 ? '#fef2f2' : 'white'
                }}
                disabled={availableDurations.length === 0}
            >
                <option value="" disabled>Длительность</option>
                {availableDurations.map(tm => (
                    <option key={tm.i} value={tm.d}>{tm.d}</option>
                ))}
                {availableDurations.length === 0 && (
                    <option value="" disabled>Нет доступных слотов</option>
                )}
            </Select>
        </div>
    );
}

// Компонент элемента занятия
function ClassItem({ classData, user, deleteClass, cancelClass, clearAddTimes, isBirthdayMatch }) {
    return (
        <div style={{
            padding: '16px',
            border: '1px solid #e1e5e9',
            borderRadius: '8px',
            backgroundColor: '#f8fafc',
            position: 'relative'
        }}>
            {/* Плашка дня рождения */}
            {isBirthdayMatch && (
                <div style={{
                    position: 'absolute',
                    top: '-10px',
                    right: '12px',
                    backgroundColor: '#10b981',
                    color: 'white',
                    padding: '4px 12px',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: '600',
                    zIndex: 1,
                    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}>
                    🎉 занятие совпадает с днем рождения
                </div>
            )}

            <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: '12px'
            }}>
                <div style={{ flex: 1 }}>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        marginBottom: '8px',
                        flexWrap: 'wrap'
                    }}>
                        <span style={{
                            fontSize: '16px',
                            fontWeight: '600',
                            color: '#1a1a1a'
                        }}>
                            {classData.student}
                        </span>
                        {classData.second_student && (
                            <span style={{
                                fontSize: '14px',
                                color: '#6b7280'
                            }}>
                                + {classData.second_student}
                            </span>
                        )}
                    </div>
                    <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '12px',
                        flexWrap: 'wrap'
                    }}>
                        <span style={{
                            fontSize: '14px',
                            color: '#6b7280',
                            backgroundColor: '#f1f5f9',
                            padding: '4px 8px',
                            borderRadius: '6px'
                        }}>
                            {classData.time} - {clearAddTimes(addTimes([classData.time, classData.duration]))}
                        </span>
                        <span style={{
                            fontSize: '14px',
                            color: '#6b7280'
                        }}>
                            {classData.duration}
                        </span>
                        {
                            user.role !== 'student' && (
                                <span style={{
                                    fontSize: '14px',
                                    fontWeight: '500',
                                    color: '#059669'
                                }}>
                            {classData.price} ₽
                                </span>
                            )
                        }
                    </div>
                </div>

                <div style={{
                    display: 'flex',
                    gap: '8px',
                    flexShrink: 0
                }}>
                    {user?.role !== 'student' && (
                        <Button
                            variant="danger"
                            onClick={() => deleteClass(classData.id)}
                        >
                            Удалить
                        </Button>
                    )}
                    <Button
                        variant="warning"
                        onClick={() => cancelClass(classData)}
                    >
                        Отменить
                    </Button>
                </div>
            </div>
        </div>
    );
}